<template>
    <div class="d-flex flex-column">
        <div class="d-flex flex-wrap gap-1">
            <div role="group" class="color-input m-0 form-group" v-for="(color, index) in colors" :key="index">
                <!-- Remove color -->
                <button type="button" class="close" aria-label="Close" @click="removeColor(index)">
                    <span class="float-right" aria-hidden="true">&times;</span>
                </button>
                <!-- Inputs -->
                <CInput class="color-input m-0" type="color" v-model="colors[index]"/>
            </div>
        </div>
        <div class="d-flex flex-wrap gap-1">
            <!-- Add more -->
            <CButton type="button" class="btn btn-secondary" :style="{margin: '20px 0', height: '30px'}" @click="addMore">{{ $t('add') }}</CButton>
        </div>
        <div v-if="isValid === false" class="invalid-feedback d-block">{{invalidFeedback}}</div>
    </div>
</template>

<script>
export default {
    props:{    
        value:
        {
            type: Array,
            default: () => []
        },
        isValid: null,
        invalidFeedback:
        {
            type: String,
            default: null,
        }
    },
    data()
    {
        return {
            colors: this.value
        }
    },
    methods:
    {
        addMore: function()
        {
            this.colors.push("#000000");
        },
        removeColor: function(index)
        {
            this.colors.splice([index], 1)
        }
    },
    watch:
    {
        value: function(val)
        {
            this.colors = val;
        },
        colors: function(val)
        {
            this.$emit('input', val);
        }
    }
}
</script>

<style scoped>
.color-input,
button
{
    width: 100px;
    padding: 0;
}
</style>